import React from 'react';

function StatusButton({ btName, className }: any) {
    return (
        <button className={className}>
            {btName}    
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </button>
    );
}

export default StatusButton;
